import React from "react";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import SVG from "react-inlinesvg";

const AppSection = () =>{
    return(
        <div className="container px-8 mt-15 mb-20">
                
                <div className="d-flex align-items-center justify-content-around mt-4 flex-wrap">
                    <div >
                        <img
                            className="img-fluid"
                            src={toAbsoluteUrl(`media/General/AppImageHome.png`)}
                            alt="AppImage"
                        />
                    </div>
                    <div>
                        <div className="">
                            <div className="app-title font-weight-bold text-left">DOC Supplier Center APP is LIVE!</div>
                        </div>
                        <p class="font-size-lg mt-5 text-left">
                            We are thrilled to announce the official launch of the DOC Supplier Center App<br /> a revolutionary platform designed to transform how diamond suppliers list, sell, <br />and manage inventory in today's fast-paced market.
                        </p>
                        {/* <div className="download-text">Download Now:</div> */}
                        <div className="d-flex mt-md-8 mt-5 justify-content-center justify-content-md-start">
                            <div className="d-flex justify-content-center flex-column mr-md-20 mr-12">
                                
                                <a href="https://play.google.com/store/apps/details?id=com.diamondsoncall.seller" rel="noreferrer" target="_blank">
                                    <img
                                        className="img-fluid"
                                        src={toAbsoluteUrl(
                                            `media/General/GooglePlay.png`
                                        )}
                                        alt="GooglePlay"
                                        height={50}
                                    />
                                </a>
                                <a href="https://apps.apple.com/in/app/doc-seller-diamond-marketplace/id6744265378" rel="noreferrer" target="_blank">
                                    <img
                                        className="img-fluid mt-10"
                                        src={toAbsoluteUrl(
                                            `media/General/AppStore.png`
                                        )}
                                        alt="AppStore"
                                        height={50}

                                    />
                                </a>
                            </div>
                            <div >
                                <SVG
                                height={120}
                                width={120}
                                    src={toAbsoluteUrl(
                                        `media/General/AppQr.svg`
                                    )}
                                />
                            </div>
                        </div>
                        {/* <div className="dont-size-h6 text-muted text-left mt-5">*Available on iPhone, iPad and all Android devices</div> */}

                    </div>
                </div>
            </div>
    )
}

export default AppSection;